<template>
   <div class="rentacar-card-debugger-container">
      <div class="rentacar-card-debugger-inner-container">
         <div>{{ JSON.stringify(infos, null, 2) }}</div>
      </div>
   </div>
</template>

<script>
export default {
   name: "RentACarCardDebugger",
   props: {
      infos: {
         type: Object,
         required: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.rentacar-card-debugger-container {
   background-color: var(--gray-700);
   color: var(--leaf-500);
   font-family: monospace;
   font-weight: 500;
   font-size: 1rem;
   padding: 0.5rem;
   margin: 0.5rem;
   border-radius: 0.5rem;

   .rentacar-card-debugger-inner-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: auto;
   }
}
</style>
